import {
  Directive,
  effect,
  HostListener,
  inject,
  type OnChanges,
  type SimpleChanges,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { UAParser } from 'ua-parser-js';

@Directive({
  selector: '[appShowOnDesktop]',
  standalone: true,
})
export class ShowOnDesktopDirective implements OnChanges {
  readonly #templateRef = inject(TemplateRef);
  readonly #viewContainer = inject(ViewContainerRef);

  constructor() {
    effect(() => {
      this.updateView();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appHasAccess'] !== undefined && changes['appHasAccess'].firstChange === false) {
      this.updateView();
    }
  }

  @HostListener('window:resize', [])
  onResize(): void {
    this.updateView();
  }

  private updateView(): void {
    const { device } = UAParser(window.navigator.userAgent);

    if (!(device.is('mobile') || device.is('tablet'))) {
      if (this.#viewContainer.length === 0) {
        this.#viewContainer.createEmbeddedView(this.#templateRef);
      }
    } else {
      this.#viewContainer.clear();
    }
  }
}
